import { render, staticRenderFns } from "./SocialProofDialog.vue?vue&type=template&id=09eb8940&scoped=true&"
import script from "./SocialProofDialog.vue?vue&type=script&lang=js&"
export * from "./SocialProofDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialProofDialog.vue?vue&type=style&index=0&id=09eb8940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb8940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCol,VForm,VRow,VSelect,VTextField,VTextarea})
